// extracted by mini-css-extract-plugin
export default {"newBadge":"irHSE5","highlightNewBadge":"sjdaDN"};